module.exports = __webpack_public_path__ + "img/ltkcurves-3x.fe00c31.jpg";